import axios from "axios";
import { domain } from "./constants";

const headers = {
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, x-requested-with",
  "Content-Type": "application/json",
  "Access-Control-Allow-origin": "*",
};
const getAuthHeaders = () => {
  const token = localStorage.getItem("access") || localStorage.getItem("access");
  let header = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return header;
};

export const getAllDuonuts = (id, cb) => {
  axios
    .get(
      `${domain}/duonut/`,
      {
        params: {
          // activity_category_id: 1,
          visibility: true,
          ordering: "priority",
        },
      },
      headers
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const getMyDuonuts = (cb) => {
  axios
    .get(
      `${domain}/duonut/`,
      {
        params: {
          created_by: localStorage.getItem("userId"),
          ordering: "priority",
        },
      },
      headers
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const getDuonut = (id, cb) => {
  const header = getAuthHeaders();
  axios
    .get(
      `${domain}/duonut/${id}`,
      {
        params: {
          ordering: "priority",
        },
      },
      header
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};
export const deleteDuonut = (id, cb) => {
  const header = getAuthHeaders();
  axios
    .delete(
      `${domain}/duonut/${id}`,
      header
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};
